import { useEffect, useState } from "react";
import { FoundationsInput } from "../../GenericComponents/input";
import { fetchcolumns, fetchObjects, fetchtables } from "../../Redux/Admin_Tasks/MDSSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../Redux/store";
import { FoundationsSelect } from "../../GenericComponents/select";
import { FoundationsButton } from "../../GenericComponents/button";
import { FoundationsCheckBox } from "../../GenericComponents/checkbox";
import { FoundationsEnums } from "../../FoundationsEnums";

interface CustomColumn {
    index: number;
    column: any;
    onFormChange: (updatedColumn: any) => void;
    //onRemove?:(index:number)=>void;
    isCustomCol: boolean;

}
const MDSCForm: React.FC<CustomColumn> = ({ index, column, onFormChange, isCustomCol = false }) => {
    const dispatch: AppDispatch = useDispatch();
    const [OCVs, setOCV] = useState<any[]>([]);
    const [tableName, settableName] = useState<any[]>([])
    const [columnName, setcolumnName] = useState<any[]>([])
    let [formData, setFormData] = useState({
        Id: column.Id || 0,
        MetaDataDrillThruSetId: column.MetaDataDrillThruSetId || null,
        MetaDataId: column.MetaDataId ? column.MetaDataId : column.FieldKey || null,
        DataType: column.DataType || 0,
        FieldName: column.FieldName || "",
        DisplayOrder: column.DisplayOrder || 0,
        TableName: column.TableName || "",
        ColumnName: column.ColumnName || "",
        EmptyColor: column.EmptyColor || "",
        JavascriptTarget: column.JavascriptTarget || "",
        JavascriptTargetParams: column.JavascriptTargetParams || "",
        hideInDrillThru: column.hideInDrillThru ?? false,
        APIContext: column.APIContext || "",
        AllowedPrivileges: column.AllowedPrivileges || "",
        fk_ocvid: column.fk_ocvid || null,
        SortOrder: column.SortOrder || "",
        DisplayTruncateColumn: column.DisplayTruncateColumn ?? true,
        IsSortable: column.IsSortable || false,
        IsNavigationAllowed: column.IsNavigationAllowed || false,
        Fk_TableName: column.Fk_TableName || -1,
        FieldDesc: column.FieldDesc || '',
        JavascriptParameterTitle: column.JavascriptParameterTitle || '',
        ApiContext: column.ApiContext || '',
        storedProcedureToFetchTargetObject: column.storedProcedureToFetchTargetObject || ''
    });
    const HLDataTypeOptions = Object.entries(FoundationsEnums.HLDataType)
        .filter(([key, value]) => isNaN(Number(key)))
        .map(([key, value]) => ({ value, label: key }));

    useEffect(() => {
        const fetchOCV = async () => {
            // Dispatch fetchObjects and wait for it to resolve
            const response = await dispatch(fetchObjects()).unwrap(); // Use unwrap to get the payload directly
            setOCV(response.data); // Assuming response.data holds the data
        };

        const fetchtablenames = async () => {
            const response = await dispatch(fetchtables()).unwrap();
            settableName(response.data);
        };

        fetchOCV();

        if (isCustomCol) {
            fetchtablenames();
        }
    }, [dispatch, isCustomCol]);


    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target;

        if (type === "checkbox") {
            const checked = (e.target as HTMLInputElement).checked;
            setFormData({ ...formData, [name]: checked });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };
    // const handleRemove = (e: React.FormEvent) => {
    //     if (onRemove) {
    //         onRemove(index); 
    //     }
    // };
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onFormChange(formData);
    };
    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedOCVId = parseInt(e.target.value, 10);
        const selectedOCV = OCVs.find(ocv => ocv.Id === selectedOCVId);
        const syntheticEvent = {
            target: {
                name: "fk_ocvid",
                value: selectedOCV?.Id || "",
            },
        } as React.ChangeEvent<HTMLInputElement | HTMLSelectElement>;

        handleInputChange(syntheticEvent);
    };
    const handleTableName = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedOptions = Array.from(e.target.selectedOptions);
        const selectedValues = selectedOptions.map(option => option.value);
        setFormData(prevState => ({
            ...prevState,
            TableName: selectedValues,
            ColumnName: `${prevState.ColumnName + selectedValues}`, // Join selected table names
        }));
    };

    const fetchColumnNames = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const tableObject = tableName.find(item => item.Id === Number(e.target.value));
        formData.Fk_TableName = tableObject.Id;
        const response = await dispatch(fetchcolumns(tableObject.TableName)).unwrap();
        setcolumnName(response.data);
    };

    return (
        <div style={{ marginBottom: '1rem', marginRight: "-1rem" }}>
            <form onSubmit={handleSubmit} style={{marginLeft:'7rem',marginTop:'1rem'}}>

                <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                    <h3 style={{ marginRight: "-5rem" }}>Field Description: {formData.FieldDesc}</h3>
                </div>
                {isCustomCol ? (
                    <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                        <label htmlFor='DataType'>DataType:</label>
                        <FoundationsSelect
                            name="DataType"
                            id="DataType"
                            value={Number(formData.DataType) || ""}
                            onChange={handleInputChange}
                        >
                            <option value="" >Select a DataType</option>
                            {HLDataTypeOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </FoundationsSelect>
                    </div>) : null}
                <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                    <label htmlFor='FieldName'>Field Name (Required):</label>
                    <FoundationsInput
                        type='text'
                        name="FieldName"
                        id="FieldName"
                        value={formData.FieldName}
                        maxLength={100}
                        placeHolder='Enter Field Name'
                        onInput={handleInputChange}
                    />
                </div>
                {isCustomCol ? (
                    <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                        <label htmlFor='TableName'>Table Name:</label>
                        <FoundationsSelect
                            name="TableName"
                            id="TableName"
                            value=""
                            onChange={fetchColumnNames}
                        >
                            <option value="">Select a TableName</option>
                            {tableName.map((col) => (
                                <option key={col.Id} value={col.Id}>
                                    {col.TableName}
                                </option>
                            ))}
                        </FoundationsSelect>

                        {columnName.length > 0 && (
                            <>
                                <label htmlFor='AliasName'>Select AliasName for Customized Column:</label>
                                <FoundationsSelect
                                    name="AliasName"
                                    id="AliasName"
                                    value=''
                                    onChange={handleTableName}
                                >
                                    <option value="">Select a Column Name</option>
                                    {columnName.map((col) => (
                                        <option key={col.Value} value={col.Value}>
                                            {col.Value}
                                        </option>
                                    ))}
                                </FoundationsSelect>
                            </>
                        )}
                        <label htmlFor='ColumnName'>Customized Column Name:</label>
                        <FoundationsInput
                            type='text'
                            name="ColumnName"
                            id="ColumnName"
                            value={formData.ColumnName}
                            placeHolder='Enter Column Name'
                            onInput={(e: any) => setFormData({ ...formData, ColumnName: e.target.value })}
                        />


                    </div>
                ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                        <label htmlFor='TableName'>Table Name:</label>
                        <FoundationsInput
                            type='text'
                            name="TableName"
                            id="TableName"
                            value={formData.TableName}
                            maxLength={100}
                            placeHolder='Enter Table Name'
                            onInput={handleTableName}
                            disabled
                        />
                    </div>
                )}

                <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                    <label htmlFor='EmptyColor'>Empty Color:</label>
                    <FoundationsInput
                        type='text'
                        name="EmptyColor"
                        id="EmptyColor"
                        value={formData.EmptyColor}
                        maxLength={100}
                        placeHolder='Enter Empty Color'
                        onInput={handleInputChange}
                    />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                    <label htmlFor='JavascriptTarget'>Javascript Target:</label>
                    <FoundationsSelect
                        name="JavascriptTarget"
                        id="JavascriptTarget"
                        value={formData.JavascriptTarget || ""}
                        onChange={handleInputChange}
                    >
                        <option value="" >Select a Javascript Target</option>
                        <option value="FoundationsJSTargetGenericObjectViewer">FoundationsJSTargetGenericObjectViewer</option>
                    </FoundationsSelect>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                    <label htmlFor='JavascriptTargetParams'>Javascript Target Params:</label>
                    <FoundationsInput
                    type="text"
                        name="JavascriptTargetParams"
                        id="JavascriptTargetParams"
                        value={formData.JavascriptTargetParams || ""}
                        placeHolder = 'Enter Javascript Target Params'
                        onInput={handleInputChange}
                    >
                    </FoundationsInput>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                    <label htmlFor='JavascriptParameterTitle'>Javascript Parameter Title:</label>
                    <FoundationsInput
                        type='text'
                        name="JavascriptParameterTitle"
                        id="JavascriptParameterTitle"
                        value={formData.JavascriptParameterTitle}
                        maxLength={100}
                        placeHolder='Enter Javascript Parameter Title'
                        onInput={handleInputChange}
                    />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                    <label htmlFor='ApiContext'>API Context:</label>
                    <FoundationsInput
                        type='text'
                        name="ApiContext"
                        id="ApiContext"
                        value={formData.ApiContext}
                        maxLength={100}
                        placeHolder='Enter API Context'
                        onInput={handleInputChange}
                    />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                    <label htmlFor='storedProcedureToFetchTargetObject'>Stored Procedure To Fetch Target Object:</label>
                    <FoundationsInput
                        type='text'
                        name="storedProcedureToFetchTargetObject"
                        id="storedProcedureToFetchTargetObject"
                        value={formData.storedProcedureToFetchTargetObject}
                        maxLength={100}
                        placeHolder='Enter Stored Procedure To Fetch Target Object'
                        onInput={handleInputChange}
                    />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                    <label htmlFor='fk_ocvid'>Select OCV:</label>
                    <FoundationsSelect
                        name="fk_ocvid"
                        id="fk_ocvid"
                        value={formData.fk_ocvid || ""}
                        onChange={handleSelectChange}
                    >
                        <option value="">Select OCV</option>
                        {OCVs.map((ocv) => (
                            <option key={ocv.Id} value={ocv.Id}>
                                {ocv.Name}
                            </option>
                        ))}
                    </FoundationsSelect>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                    <label htmlFor='AllowedPrivileges'>Allowed Privileges:</label>
                    <FoundationsInput
                        type='text'
                        name="AllowedPrivileges"
                        id="AllowedPrivileges"
                        value={formData.AllowedPrivileges}
                        maxLength={100}
                        placeHolder='Enter Allowed Privileges'
                        onInput={handleInputChange}
                    />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                    <label htmlFor='hideInDrillThru'>Hide in DrillThru:</label>
                    <FoundationsCheckBox
                        id="hideInDrillThru"
                        name="hideInDrillThru"
                        checked={formData.hideInDrillThru}
                        onChange={handleInputChange}
                    >
                    </FoundationsCheckBox>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                    <label htmlFor='DisplayTruncateColumn'>Display Truncate Column:</label>
                    <FoundationsCheckBox
                        id="DisplayTruncateColumn"
                        name="DisplayTruncateColumn"
                        checked={formData.DisplayTruncateColumn}
                        onChange={handleInputChange}
                    >
                    </FoundationsCheckBox>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                    <label htmlFor='IsSortable'>Is Sortable:</label>
                    <FoundationsCheckBox
                        id="IsSortable"
                        name="IsSortable"
                        checked={formData.IsSortable}
                        onChange={handleInputChange}
                    >
                    </FoundationsCheckBox>
                </div>
                <div style={{ display: 'flex'}}>
                    {/* <FoundationsButton
                        buttonClasses="ui-button app-button"
                        id={`remove_button_${index}`}
                        onClick={handleRemove} 
                        customStyle={{ cursor: 'pointer', marginLeft: '10px' }}
                    >
                        Remove
                    </FoundationsButton> */}
                    <FoundationsButton type="submit" buttonClasses="ui-button app-button" id={""} customStyle={{marginLeft:'10rem'}}>Save</FoundationsButton>
                </div>
            </form>
        </div>
    );
};

export default MDSCForm;